import { AuthenticationResult, EventType } from "@azure/msal-browser";
import { ReactNode, useEffect, useState } from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../authConfig";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        // Await initialization before proceeding
        await msalInstance.initialize();
        
        // Set active account if available
        const allAccounts = msalInstance.getAllAccounts();
        if (allAccounts.length > 0) {
          msalInstance.setActiveAccount(allAccounts[0]);
        }

        // Register callback for login events
        const callbackId = msalInstance.addEventCallback((event) => {
          if (event.eventType === EventType.LOGIN_SUCCESS) {
            const authResult = event.payload as AuthenticationResult;
            if (authResult.account) {
              msalInstance.setActiveAccount(authResult.account);
            }
          }
        });

        setIsInitialized(true);
        
        // Clean up event listener on unmount
        return () => {
          if (callbackId) {
            msalInstance.removeEventCallback(callbackId);
          }
        };
      } catch (error) {
        console.error("MSAL initialization error:", error);
        // Show initialization error to user
        setIsInitialized(true); // Still show UI but with error state
      }
    };

    initializeMsal();
  }, []);

  if (!isInitialized) {
    // Show loading indicator
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading authentication...
      </div>
    );
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default AuthProvider;